export const CARD_CURRENCY_PARAM = 'cardCurrency'
